import React from 'react';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import PauseOutlinedIcon from '@mui/icons-material/PauseOutlined';
import StopOutlinedIcon from '@mui/icons-material/StopOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import ThumbUpOffAltOutlinedIcon from '@mui/icons-material/ThumbUpOffAltOutlined';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import WifiOutlinedIcon from '@mui/icons-material/WifiOutlined';
import BluetoothOutlinedIcon from '@mui/icons-material/BluetoothOutlined';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import FlightTakeoffOutlinedIcon from '@mui/icons-material/FlightTakeoffOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import TrainOutlinedIcon from '@mui/icons-material/TrainOutlined';
import PetsOutlinedIcon from '@mui/icons-material/PetsOutlined';
import SportsSoccerOutlinedIcon from '@mui/icons-material/SportsSoccerOutlined';
import RestaurantOutlinedIcon from '@mui/icons-material/RestaurantOutlined';
import LocalCafeOutlinedIcon from '@mui/icons-material/LocalCafeOutlined';
import LocalBarOutlinedIcon from '@mui/icons-material/LocalBarOutlined';
import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import BeachAccessOutlinedIcon from '@mui/icons-material/BeachAccessOutlined';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import MedicalInformationOutlinedIcon from '@mui/icons-material/MedicalInformationOutlined';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import EuroOutlinedIcon from '@mui/icons-material/EuroOutlined';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import LoyaltyOutlinedIcon from '@mui/icons-material/LoyaltyOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import DirectionsWalkOutlinedIcon from '@mui/icons-material/DirectionsWalkOutlined';
import DirectionsBikeOutlinedIcon from '@mui/icons-material/DirectionsBikeOutlined';
import HikingOutlinedIcon from '@mui/icons-material/HikingOutlined';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';
import MusicNoteOutlinedIcon from '@mui/icons-material/MusicNoteOutlined';
import MovieOutlinedIcon from '@mui/icons-material/MovieOutlined';
import HeadphonesOutlinedIcon from '@mui/icons-material/HeadphonesOutlined';
import SportsEsportsOutlinedIcon from '@mui/icons-material/SportsEsportsOutlined';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import LaptopOutlinedIcon from '@mui/icons-material/LaptopOutlined';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';
import TabletAndroidOutlinedIcon from '@mui/icons-material/TabletAndroidOutlined';

export const ICONS: Record<string, React.ReactNode> = {
  home: <HomeOutlinedIcon />,
  star: <StarBorderOutlinedIcon />,
  favorite: <FavoriteBorderOutlinedIcon />,
  cart: <ShoppingCartOutlinedIcon />,
  info: <InfoOutlinedIcon />,
  check: <CheckCircleOutlineOutlinedIcon />,
  warning: <WarningAmberOutlinedIcon />,
  phone: <PhoneOutlinedIcon />,
  email: <EmailOutlinedIcon />,
  location: <PlaceOutlinedIcon />,
  category: <CategoryOutlinedIcon />,
  label: <LabelOutlinedIcon />,
  link: <LinkOutlinedIcon />,
  arrow: <ArrowForwardOutlinedIcon />,
  search: <SearchOutlinedIcon />,
  settings: <SettingsOutlinedIcon />,
  user: <PersonOutlineOutlinedIcon />,
  calendar: <CalendarTodayOutlinedIcon />,
  time: <AccessTimeOutlinedIcon />,
  upload: <UploadOutlinedIcon />,
  download: <DownloadOutlinedIcon />,
  delete: <DeleteOutlineOutlinedIcon />,
  edit: <EditOutlinedIcon />,
  share: <ShareOutlinedIcon />,
  play: <PlayArrowOutlinedIcon />,
  pause: <PauseOutlinedIcon />,
  stop: <StopOutlinedIcon />,
  chat: <ChatBubbleOutlineOutlinedIcon />,
  send: <SendOutlinedIcon />,
  like: <ThumbUpOffAltOutlinedIcon />,
  bookmark: <BookmarkBorderOutlinedIcon />,
  globe: <PublicOutlinedIcon />,
  wifi: <WifiOutlinedIcon />,
  bluetooth: <BluetoothOutlinedIcon />,
  sun: <WbSunnyOutlinedIcon />,
  moon: <DarkModeOutlinedIcon />,
  cloud: <CloudOutlinedIcon />,
  bolt: <BoltOutlinedIcon />,
  offer: <LocalOfferOutlinedIcon />,
  store: <StorefrontOutlinedIcon />,
  shipping: <LocalShippingOutlinedIcon />,
  flight: <FlightTakeoffOutlinedIcon />,
  car: <DirectionsCarOutlinedIcon />,
  train: <TrainOutlinedIcon />,
  pet: <PetsOutlinedIcon />,
  soccer: <SportsSoccerOutlinedIcon />,
  restaurant: <RestaurantOutlinedIcon />,
  cafe: <LocalCafeOutlinedIcon />,
  bar: <LocalBarOutlinedIcon />,
  hotel: <HotelOutlinedIcon />,
  beach: <BeachAccessOutlinedIcon />,
  hospital: <LocalHospitalOutlinedIcon />,
  medical: <MedicalInformationOutlinedIcon />,
  science: <ScienceOutlinedIcon />,
  school: <SchoolOutlinedIcon />,
  work: <WorkOutlineOutlinedIcon />,
  card: <CreditCardOutlinedIcon />,
  paid: <PaidOutlinedIcon />,
  euro: <EuroOutlinedIcon />,
  bag: <LocalMallOutlinedIcon />,
  loyalty: <LoyaltyOutlinedIcon />,
  call: <LocalPhoneOutlinedIcon />,
  map: <MapOutlinedIcon />,
  walk: <DirectionsWalkOutlinedIcon />,
  bike: <DirectionsBikeOutlinedIcon />,
  hike: <HikingOutlinedIcon />,
  camera: <CameraAltOutlinedIcon />,
  brush: <BrushOutlinedIcon />,
  music: <MusicNoteOutlinedIcon />,
  movie: <MovieOutlinedIcon />,
  headphones: <HeadphonesOutlinedIcon />,
  game: <SportsEsportsOutlinedIcon />,
  tools: <ConstructionOutlinedIcon />,
  build: <BuildOutlinedIcon />,
  laptop: <LaptopOutlinedIcon />,
  phone2: <SmartphoneOutlinedIcon />,
  tablet: <TabletAndroidOutlinedIcon />,
};

export const ICON_CATEGORIES: Record<string, string[]> = {
  Alle: Object.keys(ICONS),
  System: ['search','settings','info','check','warning','edit','delete','share','upload','download','arrow','label','link'],
  Nutzer: ['user','phone','call','email'],
  Zeit: ['calendar','time'],
  Medien: ['play','pause','stop','music','movie','headphones','camera'],
  Social: ['chat','send','like','bookmark','globe'],
  Netzwerk: ['wifi','bluetooth','cloud'],
  Wetter: ['sun','moon','cloud','bolt'],
  Shop: ['cart','store','bag','offer','loyalty','card','paid','euro','category'],
  Reisen: ['flight','car','train','map','location','hotel','beach'],
  Essen: ['restaurant','cafe','bar'],
  Sport: ['soccer','walk','bike','hike','game'],
  Tiere: ['pet'],
  Gesundheit: ['hospital','medical','science'],
  Bildung: ['school'],
  Arbeit: ['work','tools','build','laptop','phone2','tablet'],
};
